import AttachmentUpload from '../../../../components/AttachmentUpload';
import { RecordFile } from '../../../../types';
import { MaterialRequestRecord } from '../../../../types/MaterialRequest';
import React from 'react';
import MaterialRequestInfoView from './MaterialRequestInfoView';
import MaterialRequestInfoTabs from './MaterialRequestInfoTabs';

interface MaterialRequestInfoContentProp {
  data?: MaterialRequestRecord;
  attachments?: RecordFile[];
  /** Set together to allow adding/removing; omit any and the list stays read-only. */
  api?: string;
  recordId?: string;
  canEdit?: boolean;
}

const MaterialRequestInfoContent: React.FC<MaterialRequestInfoContentProp> = ({
  data,
  attachments,
  api,
  recordId,
  canEdit,
}) => {
  return (
    <>
      <div className={'w-9/12 space-y-4 h-[calc(84vh)] overflow-auto m'}>
        <div className={'p-4 rounded'}>
          <MaterialRequestInfoView data={data} />
          <AttachmentUpload
          attachments={attachments}
          api={api}
          recordId={recordId}
          canEdit={canEdit}
        />
          <MaterialRequestInfoTabs data={data} />
        </div>
      </div>
    </>
  );
};

export default MaterialRequestInfoContent;
